import { useEffect } from "react";

export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => {
    if (title == null || title === "") return;
    document.title = title;
  }, [title]);
}
